import React, { useState, useEffect } from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./PhoneNumberInput.scss";

interface PhoneNumberInputProps {
  defaultCountry?: string; 
  onChange?: (phone: string | undefined) => void;
  value?: string;
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  defaultCountry = "il", 
  onChange,
  value = ""
}) => {
  const [phone, setPhone] = useState<string | undefined>(value);

  useEffect(() => {
    setPhone(value);
  }, [value]);

  const handlePhoneChange = (val: string | undefined) => {
    setPhone(val);
    onChange?.(val);
  };

  return (
    <div >
      <PhoneInput
      international
        country={defaultCountry}
        value={phone}
        onChange={handlePhoneChange}
        placeholder="Enter phone number"
      />
    </div>
  );
};

export default PhoneNumberInput;
